import React from 'react'
import Wishlist from '../components/Wishlist'
const WIshlist = () => {
    return (
        <>
            <Wishlist />
        </>
    )
}

export default WIshlist